module.exports = __webpack_public_path__ + "media/images/img-mirror-ffe58d3d811edf2cd8e6fa25df8c1166.png";